<nav class="mt-30 acm-portal-nav">
  @for (item of navigationItems; track item) {
  <a class="pl-0 acm-portal-nav-item" #lvl1Nav="routerLinkActive" [routerLink]="'/portal/' + item.path"
    [routerLinkActive]="['is-active']">
    <span class="relative flex flex-col items-center justify-center w-64 h-48"
      [matTooltip]="showSubNavigation ? item.navigation!.name : ''" matTooltipPosition="right">
      @if (item.navigation!.icon) {
      <mat-icon class="mi-18" [svgIcon]="item.navigation!.icon"></mat-icon>
      }
      @if (item.navigation!.figIcon) {
      <i class="fig-18px {{item.navigation?.figIcon}}"></i>
      }     
    </span>
    @if (item.navigation) {
      <span class="acm-portal-nav-label">{{item.navigation.name}}</span>
      <!-- @if (item.navigation!.name === 'Accounts') {        
        <span class="text-2xl pt-5 pl-5 ml-2 text-orange">*</span>
        <span class="pb-2 pt-2 pr-5 italic text-xs 
        text-orange uppercase" matTooltip="Real-time investment account data is now available by clicking on any investment account.">New Updates!</span>             
      }      -->
    }
  </a>
  }
  @if (showSubNavigation) {
  <app-sub-navigation [subNavigationItems]="subNavigationItems"></app-sub-navigation>
  }
  <div class="flex flex-col py-10 mt-auto border-t border-solid gap-y-10 border-gray-lighter dark:border-gray-dark">   
    <ng-conainer *appShowIfAll="perm.ViewOrionConnectSso">
      <ng-conainer>
        <a class="pl-0 acm-portal-nav-item" href="api/sso/orion/connect" target="_blank" rel="noopener"
          aria-label="Orion Advisor Solutions">
          <span class="relative flex flex-col items-center justify-center w-64 h-48"
            [matTooltip]="showSubNavigation ? 'Orion Advisor Solutions' : ''" matTooltipPosition="right">
            <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/orion-logo.png">
          </span>
          <span class="acm-portal-nav-label">Orion Advisor Solutions</span>
        </a>
      </ng-conainer>
    </ng-conainer>
    <ng-conainer *appShowIfOne="perm.ViewOrionElementSso">
      <a class="pl-0 acm-portal-nav-item" (click)="openOrionAgentSelectModal('ap_dashboard')" aria-label="Orion">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Orion' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/orion-logo.png">
        </span>
        <span class="acm-portal-nav-label">Orion Advisor Portal</span>
      </a>
    </ng-conainer>
    <ng-conainer *appShowIfAll="perm.ViewComplianceCentralSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/basis-code" target="_blank" rel="noopener"
        aria-label="Orion Compliance">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Orion Compliance' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/orion-logo.png">
        </span>
        <span class="acm-portal-nav-label">Orion Compliance</span>
      </a>
    </ng-conainer>
    <ng-conainer *appShowIfAll="perm.ViewFidelityWealthscapeSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/fidelity" target="_blank" rel="noopener"
        aria-label="Fidelity Wealthscape">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Fidelity Wealthscape' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/fidelity_wealthscape_logo.png">
        </span>
        <span class="acm-portal-nav-label">Fidelity Wealthscape</span>
      </a>
      <!-- <a class="pl-0 acm-portal-nav-item" href="https://www.wealthscape.com/" target="_blank" rel="noopener"
        aria-label="Fidelity Wealthscape">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Fidelity Wealthscape' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/fidelity_wealthscape_logo.png">
        </span>
        <span class="acm-portal-nav-label">Fidelity Wealthscape</span>
      </a> -->
    </ng-conainer>    
    <ng-conainer *appHideIfOne="perm.ViewSchwabAdvisorCenterSso">
      <a class="pl-0 acm-portal-nav-item"
        href="https://si2.schwabinstitutional.com/SI2/SecAdmin/Logon.aspx?to=%2fSI2%2fHome%2fDefault.aspx"
        target="_blank" rel="noopener" aria-label="Schwab Advisor Center Login">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Schwab Advisor Center Login' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/schwab-logo.png">
        </span>
        <span class="acm-portal-nav-label">Schwab Advisor Center</span>
      </a>
    </ng-conainer>
    <ng-conainer *appShowIfAll="perm.ViewSchwabAdvisorCenterSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/schwab?destination=D_DASH" target="_blank" rel="noopener"
        aria-label="Schwab Advisor Center">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Schwab Advisor Center' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/schwab-logo.png">
        </span>
        <span class="acm-portal-nav-label">Schwab Advisor Center</span>
      </a>
    </ng-conainer>    
    <ng-conainer *appShowIfAll="perm.ViewLumaSso">
      <a class="pl-0 acm-portal-nav-item" (click)="openLumaAgentSelectModal()" aria-label="Luma">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Luma' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/luma-logo-blue.svg">
        </span>
        <span class="acm-portal-nav-label">Luma</span>
      </a>
    </ng-conainer>
    <ng-conainer *appShowIfAll="perm.ViewEnvestnetSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/envestnet" target="_blank" rel="noopener"
        aria-label="Envestnet">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Envestnet' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/envestnet-logo.png">
        </span>
        <span class="acm-portal-nav-label">Envestnet</span>
      </a>
    </ng-conainer>
    <ng-conainer *appShowIfAll="perm.ViewPonteraSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/pontera" target="_blank" aria-label="Pontera">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Pontera' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/pontera.png">
        </span>
        <span class="acm-portal-nav-label">Pontera</span>
      </a>
    </ng-conainer>  
    <ng-conainer *appHideIfOne="perm.ViewPonteraSso">
      <a class="pl-0 acm-portal-nav-item" href="https://advisor.pontera.com/business/auth/signin" target="_blank" aria-label="Pontera">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Pontera' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/pontera.png">
        </span>
        <span class="acm-portal-nav-label">Pontera</span>
      </a>
    </ng-conainer>  
    <ng-conainer *appShowIfAll="perm.ViewInvestorcomSso">
      <a class="pl-0 acm-portal-nav-item" href="api/sso/investorcom" target="_blank" aria-label="Investorcom">
        <span class="relative flex flex-col items-center justify-center w-64 h-48"
          [matTooltip]="showSubNavigation ? 'Investorcom' : ''" matTooltipPosition="right">
          <img class="w-auto h-25 m-auto" src="assets/images/logos/navigation/investorcom.png">
        </span>
        <span class="acm-portal-nav-label">Investorcom</span>
      </a>
    </ng-conainer>  
  </div>
</nav>